module.exports = __webpack_public_path__ + "img/carshina22_22.15c52600.jpg";